import { Link } from 'gatsby'
import React, { memo } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { linkResolver } from '../../utils/linkResolver'
import Pagination from '../Pagination'
import PostPreview from '../PostPreview'

const PAGE_SIZE = 9
const MOBILE_PAGE_SIZE = 5

const ArticleList = ({ data, currentPage, setCurrentPage }) => {
  const { isMatching, calculated } = useMatchMedia('(max-width:610px)', true)
  const pageSize = isMatching && calculated ? MOBILE_PAGE_SIZE : PAGE_SIZE

  return (
    <>
      <div className="articles-list">
        {data?.map((node) => (
          <Link to={linkResolver(node)} key={node}>
            <PostPreview data={node} />
          </Link>
        ))}
      </div>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={data?.length || 0}
        pageSize={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  )
}

export default memo(ArticleList)
